/** Docs explaining dilution-adjusted live market cap after SpaceX / xAI merger. */
export const ADJUSTED_MARKET_CAP_DOCS_PATH =
  '/docs/investment/exclusive-access/adjusted-market-cap'

/**
 * SpaceX / xAI pages that show an adjusted live market-cap note under Deal terms.
 * Exact `/companies/:fundUrlId` slugs.
 */
const ADJUSTED_MARKET_CAP_FUND_URL_IDS = new Set([
  'spacex',
  'spacex-series-2',
  'xai',
  'xai-series-2',
])

export function shouldShowAdjustedMarketCapInfo(fundUrlId: string): boolean {
  return ADJUSTED_MARKET_CAP_FUND_URL_IDS.has(fundUrlId.trim().toLowerCase())
}
